import { render, staticRenderFns } from "./card-row.vue?vue&type=template&id=01568b06"
import script from "./card-row.vue?vue&type=script&lang=ts"
export * from "./card-row.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01568b06')) {
      api.createRecord('01568b06', component.options)
    } else {
      api.reload('01568b06', component.options)
    }
    module.hot.accept("./card-row.vue?vue&type=template&id=01568b06", function () {
      api.rerender('01568b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/legacy/card/card-row.vue"
export default component.exports